import { Wallet } from "@app/core/wallet/domain/model/wallet";
import { TransactionWSMapper } from "@app/core/wallet/infraestructure/mapper/transaction.mapper";

export class WalletWSMapper {
  private static readonly KEY_ID = "id";
  private static readonly KEY_BALANCE = "balance";
  private static readonly KEY_TRANSACTIONS = "transactions";

  private readonly transactionWSMapper = new TransactionWSMapper();

  deserialize(data: Record<string, any>): Wallet {
    return new Wallet(
      data[WalletWSMapper.KEY_ID],
      data[WalletWSMapper.KEY_BALANCE],
      data[WalletWSMapper.KEY_TRANSACTIONS].map((transaction: Record<string, any>) =>
        this.transactionWSMapper.deserialize(transaction)
      )
    );
  }
}
